import React from 'react'
import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import DualActionButtons from '../../../components/action_button/DualActionButtons'
import {
  dialogActionButtonSx,
  dialogActionsSx,
  dialogBodyTextSx,
  dialogConfirmCardSx,
  dialogContentSx,
  dialogDividerCompactSx,
  dialogHeaderSx,
  dialogMetaTextSx,
  dialogTitleSx,
  getDialogCancelAction,
  getDialogPaperSx
} from '../../../constants/dialogSx'
import { UI_COLOR_PRIMARY, UI_COLOR_PRIMARY_HOVER } from '../../../constants/uiColors'

const dialogPaperSx = getDialogPaperSx(520)

const roleNameSx = {
  fontWeight: 700,
  color: dialogTitleSx.color,
  lineHeight: 1.3
}

export default function RbacRoleConfirmDialog({
  open,
  onClose,
  onExited,
  onConfirm,
  role,
  title,
  body,
  confirmLabel,
  confirmColor = UI_COLOR_PRIMARY,
  confirmHoverColor = UI_COLOR_PRIMARY_HOVER,
  submitting = false,
  loadingLabel = 'Guardando...'
}) {
  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onClose}
      TransitionProps={{ onExited }}
      fullWidth
      maxWidth={false}
      PaperProps={{ sx: dialogPaperSx }}
    >
      <DialogTitle sx={dialogHeaderSx}>
        <Typography component="span" sx={dialogTitleSx}>
          {title}
        </Typography>
      </DialogTitle>
      <Divider sx={dialogDividerCompactSx} />
      <DialogContent sx={dialogContentSx}>
        {body ? <Typography sx={dialogBodyTextSx}>{body}</Typography> : null}

        <Box sx={dialogConfirmCardSx}>
          <Typography sx={roleNameSx}>{role?.name || '—'}</Typography>
          <Typography sx={dialogMetaTextSx}>
            {role?.uid || '—'}
            {role?.description ? ` · ${role.description}` : ''}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={dialogActionsSx}>
        <DualActionButtons
          fullWidthOnMobile={false}
          minWidth={112}
          gap={1}
          secondaryAction={getDialogCancelAction({
            onClick: onClose,
            disabled: submitting,
            sx: dialogActionButtonSx
          })}
          primaryAction={{
            label: confirmLabel,
            loadingLabel,
            showLoadingIcon: false,
            icon: null,
            color: confirmColor,
            hoverColor: confirmHoverColor,
            onClick: onConfirm,
            disabled: submitting,
            loading: submitting,
            sx: dialogActionButtonSx
          }}
        />
      </DialogActions>
    </Dialog>
  )
}
